import _regeneratorRuntime from 'babel-runtime/regenerator';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import Singleton from 'react-singleton';
import { createStore } from 'redux';
// import AWS from "aws-sdk";
// import Amplify from 'aws-amplify';
//import { Auth } from 'aws-amplify';
import Auth from '@aws-amplify/auth';
import Amplify, { PubSub } from 'aws-amplify';
import { AWSIoTProvider } from '@aws-amplify/pubsub/lib/Providers';

var storage = window.localStorage;

var logdown = require('logdown');
var console = logdown('rx-login-login-manager', { prefixColor: '#689f38' });

export var LoginActions = {
    INIT: 0,
    LOGIN: 1,
    REQUEST_NEW_PASSWORD: 2,
    LOGIN_DONE: 3,
    EXPIRED: 4,
    LOGOUT: 5,
    REFRESH_AUTH: 6,
    RESET: 7
};

export var LoginStates = {
    UNDEFINED: -1,
    INITIALIZED: 0,
    LOGIN: 1,
    REQUEST_NEW_PASSWORD: 2,
    LOGIN_DONE: 3,
    EXPIRED: 4,
    LOGOUT: 5,
    REFRESH_AUTH: 6,
    RESET: 7
};

export var loginStore = createStore(LoginReducer);

function LoginReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var action = arguments[1];

    console.log('in reducer with: ' + state + ' and action: ' + JSON.stringify(action));
    switch (action.type) {

        case LoginActions.INIT:
            return { state: LoginStates.INITIALIZED };

        case LoginActions.LOGIN:
            return { username: action.username, password: action.password, state: LoginStates.LOGIN, cb: action.cb };

        case LoginActions.REQUEST_NEW_PASSWORD:
            return { state: LoginStates.REQUEST_NEW_PASSWORD, password: action.password, name: action.name, cb: action.cb };

        case LoginActions.LOGIN_DONE:
            return { state: LoginStates.LOGIN_DONE };

        case LoginActions.EXPIRED:
            return { state: LoginStates.EXPIRED };

        case LoginActions.LOGOUT:
            return { state: LoginStates.LOGOUT };

        case LoginActions.REFRESH_AUTH:
            return { state: LoginActions.REFRESH_AUTH, accessKeyId: action.accessKeyId, secretAccessKey: action.secretAccessKey, sessionToken: action.sessionToken };

        case LoginActions.RESET:
            return { state: LoginActions.RESET, verification_code: action.verification_code, new_password: action.new_password, username: action.username, cb: action.cb };
        default:
            return { state: LoginStates.UNDEFINED };

    }
}

export var LoginManager = function (_Component) {
    _inherits(LoginManager, _Component);

    function LoginManager(props) {
        var _this3 = this;

        _classCallCheck(this, LoginManager);

        var _this2 = _possibleConstructorReturn(this, _Component.call(this, props));

        _this2.doResetPassword = function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(verification_code, username, password, cb) {
                var result;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return Auth.forgotPasswordSubmit(username, verification_code, password);

                            case 3:
                                result = _context.sent;

                                console.log('in result with ' + JSON.stringify(result));
                                cb({ success: true }, null);
                                _context.next = 13;
                                break;

                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context['catch'](0);

                                console.log(_context.t0);
                                console.log('in error with ' + JSON.stringify(_context.t0));

                                cb(null, _context.t0);

                            case 13:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this3, [[0, 8]]);
            }));

            return function (_x2, _x3, _x4, _x5) {
                return _ref.apply(this, arguments);
            };
        }();

        _this2.doLogout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            return _context3.abrupt('return', new Promise(function () {
                                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(fulfill, reject) {
                                    var result;
                                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                                        while (1) {
                                            switch (_context2.prev = _context2.next) {
                                                case 0:
                                                    _context2.prev = 0;
                                                    _context2.next = 3;
                                                    return Auth.signOut();

                                                case 3:
                                                    result = _context2.sent;

                                                    console.log('done signOut with ' + JSON.stringify(result));
                                                    storage.authenticated = false;
                                                    fulfill();
                                                    _context2.next = 13;
                                                    break;

                                                case 9:
                                                    _context2.prev = 9;
                                                    _context2.t0 = _context2['catch'](0);

                                                    console.log('in sign out error: ' + _context2.t0);
                                                    reject();

                                                case 13:
                                                case 'end':
                                                    return _context2.stop();
                                            }
                                        }
                                    }, _callee2, _this3, [[0, 9]]);
                                }));

                                return function (_x6, _x7) {
                                    return _ref3.apply(this, arguments);
                                };
                            }()));

                        case 1:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }));


        console.log('in LoginManager with props: ' + props);

        _this2.state = {};

        // this.loginStore = loginStore;
        _this2.doLogin = _this2.doLogin.bind(_this2);
        _this2.doNewPassword = _this2.doNewPassword.bind(_this2);
        // this.doRefresh = this.doRefresh.bind(this);
        // this.doLogout = this.doLogout.bind(this);

        console.log('in login manager init');
        console.log('state: ' + JSON.stringify(_this2.state));
        var _this = _this2;
        var unsubscribe = loginStore.subscribe(function () {

            var state = loginStore.getState();
            console.log('in login store event with: ' + JSON.stringify(state));

            switch (state.state) {

                case LoginActions.LOGIN:
                    _this2.doLogin(state.username, state.password, state.cb);
                    break;

                case LoginActions.REQUEST_NEW_PASSWORD:
                    console.log('in request new password with password: ' + state.password);
                    _this2.doNewPassword(state.name, state.password, state.cb);
                    break;

                case LoginActions.EXPIRED:
                    _this2.doLogout();
                    console.log('expired login');
                    break;

                case LoginActions.LOGOUT:
                    _this2.doLogout();
                    console.log('logout');
                    break;

                case LoginActions.RESET:
                    console.log('in reset with state: ' + JSON.stringify(state));
                    _this2.doResetPassword(state.verification_code, state.username, state.new_password, state.cb);
                    break;

                default:
                    break;
            }
        });

        return _this2;
    }

    LoginManager.prototype.configure = function configure(configuration_data) {

        console.log('##11 in configuration_data: ' + JSON.stringify(configuration_data));
        this.configuration_data = configuration_data;

        if (configuration_data.pubsub) {

            console.log("##12 AddPluggableIOT");
            Amplify.addPluggable(new AWSIoTProvider({
                aws_pubsub_region: '' + configuration_data.region,
                aws_pubsub_endpoint: '' + configuration_data.pubsubEndpoint
            }));
        }

        var config = {
            // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
            identityPoolId: '' + configuration_data.identityPoolId,

            // REQUIRED - Amazon Cognito Region
            region: '' + configuration_data.region,

            // OPTIONAL - Amazon Cognito User Pool ID
            userPoolId: '' + configuration_data.userPoolId,

            // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
            userPoolWebClientId: '' + configuration_data.userPoolClientId

        };

        console.log('config: ' + JSON.stringify(config));
        Auth.configure(config);
    };

    LoginManager.prototype.doLogin = function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(username, password, cb) {
            var result;
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.prev = 0;
                            _context4.next = 3;
                            return Auth.signIn(username, password);

                        case 3:
                            result = _context4.sent;

                            // .then(user => console.log(user))
                            // .catch(err => console.log(err));
                            console.log('in result2 with ' + JSON.stringify(result));

                            if (result.challengeName != undefined && result.challengeName == 'NEW_PASSWORD_REQUIRED') {

                                console.log('need to change password');
                                this.userAttributes = result.challengeParam.userAttributes;
                                this.cognitoUser = result;
                                cb(null, { error: 'NewPasswordRequired' });
                            } else {
                                storage.authenticated = true;
                                loginStore.dispatch({ type: LoginActions.LOGIN_DONE });
                            }
                            _context4.next = 13;
                            break;

                        case 8:
                            _context4.prev = 8;
                            _context4.t0 = _context4['catch'](0);

                            console.log(_context4.t0);
                            console.log('in error with ' + JSON.stringify(_context4.t0));

                            if (_context4.t0.code == 'PasswordResetRequiredException') {

                                console.log('specific error');
                                cb(null, { error: 'PasswordResetRequiredException' });
                            } else if (_context4.t0.code == 'UserNotFoundException') {

                                console.log('user not found exception');
                                cb(null, { error: 'UserNotFoundException' });
                            } else if (_context4.t0.code == 'NotAuthorizedException') {

                                console.log('Incorrect username or password');
                                cb(null, { error: 'NotAuthorizedException' });
                            }

                        case 13:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this, [[0, 8]]);
        }));

        function doLogin(_x8, _x9, _x10) {
            return _ref4.apply(this, arguments);
        }

        return doLogin;
    }();

    LoginManager.prototype.doNewPassword = function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(name, password, cb) {
            var result, values, given_name, family_name;
            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.prev = 0;
                            _context5.next = 3;
                            return Auth.completeNewPassword(this.cognitoUser, password, { name: name });

                        case 3:
                            result = _context5.sent;

                            console.log('completeNewPasswordChallenge: ', result);
                            cb(result, null);

                            _context5.next = 27;
                            break;

                        case 8:
                            _context5.prev = 8;
                            _context5.t0 = _context5['catch'](0);


                            console.log('in error: ' + _context5.t0);

                            //Temporary FIX for multiname cognito:
                            values = name.split(" ");
                            given_name = values[0];
                            family_name = values.length > 0 ? values[1] : values[0];

                            console.log('try to complete with ', given_name, family_name);
                            _context5.prev = 15;
                            _context5.next = 18;
                            return Auth.completeNewPassword(this.cognitoUser, password, { given_name: given_name, family_name: family_name });

                        case 18:
                            result = _context5.sent;

                            console.log('completeNewPasswordChallenge: ', result);
                            cb(result, null);
                            _context5.next = 27;
                            break;

                        case 23:
                            _context5.prev = 23;
                            _context5.t1 = _context5['catch'](15);

                            console.log('error 2 with completeNewPasswordChallenge: ', _context5.t1);
                            cb(null, _context5.t1);

                        case 27:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this, [[0, 8], [15, 23]]);
        }));

        function doNewPassword(_x11, _x12, _x13) {
            return _ref5.apply(this, arguments);
        }

        return doNewPassword;
    }();

    LoginManager.prototype.doResetPassword = function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(name, code, password, cb) {
            var result;
            return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _context6.prev = 0;
                            _context6.next = 3;
                            return Auth.forgotPasswordSubmit(this.cognitoUser.username, code, password);

                        case 3:
                            result = _context6.sent;

                            console.log('complete change password: ' + result);
                            cb(result, null);

                            _context6.next = 13;
                            break;

                        case 8:
                            _context6.prev = 8;
                            _context6.t0 = _context6['catch'](0);


                            console.log('in error: ' + _context6.t0);
                            console.log('doResetPassword: ' + _context6.t0);
                            cb(null, _context6.t0.code);

                        case 13:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this, [[0, 8]]);
        }));

        function doResetPassword(_x14, _x15, _x16, _x17) {
            return _ref6.apply(this, arguments);
        }

        return doResetPassword;
    }();

    return LoginManager;
}(Component);

export var withLogin = function withLogin(WrappedComponent, manager) {

    // ...and returns another component...
    return function (_React$Component) {
        _inherits(_class2, _React$Component);

        function _class2(props) {
            _classCallCheck(this, _class2);

            var _this4 = _possibleConstructorReturn(this, _React$Component.call(this, props));

            _this4.manager = manager;
            return _this4;
        }

        _class2.prototype.render = function render() {
            return React.createElement(WrappedComponent, _extends({ loginManager: this.manager }, this.props));
        };

        return _class2;
    }(React.Component);
};

// export const LoginManager = _LoginManager;
// module.exports = {
//     manager: new LoginManager(),
//     store: loginStore,
//     actions: LoginActions,
//     withLogin: withLogin
// }